import { useState, useEffect } from "react";
import CheckpointApi from "../services/checkpointApi";

export default function useCheckpointStatus(blockNumber) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checkpointBlock, setCheckpointBlock] = useState(null);

  useEffect(() => {
    let mounted = true;

    async function fetchStatus() {
      if (!blockNumber) {
        setLoading(false);
        return;
      }

      try {
        // Find the checkpoint block that covers this block
        // Checkpoints are every 10 blocks, so block 927 is covered by checkpoint 930
        const checkpointBlockNumber = Math.ceil(blockNumber / 10) * 10;

        const checkpoint = await CheckpointApi.getCheckpoint(
          checkpointBlockNumber,
        );
        if (mounted) {
          setCheckpointBlock(checkpointBlockNumber);
          setStatus(checkpoint?.status || null);
          setLoading(false);
        }
      } catch (error) {
        if (mounted) {
          setStatus(null);
          setLoading(false);
        }
      }
    }

    fetchStatus();

    return () => {
      mounted = false;
    };
  }, [blockNumber]);

  return { status, loading, checkpointBlock };
}
